
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { User } from '@supabase/supabase-js';

export const useTripSubscription = (user: User | null, onTripsChange: () => void) => {
  // Effect to set up real-time subscription for trips
  useEffect(() => {
    if (!user) return;
    
    console.log("Setting up realtime subscription for trips");
    
    // Create a channel for owned trips
    const ownedTripsChannel = supabase
      .channel('owned-trips-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'trips',
          filter: `owner_id=eq.${user.id}`
        },
        (payload) => {
          console.log("Realtime update for owned trips:", payload);
          onTripsChange();
        }
      )
      .subscribe();
      
    // Create a channel for joined trips (trip_members table)
    const joinedTripsChannel = supabase
      .channel('joined-trips-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'trip_members',
          filter: `user_id=eq.${user.id}`
        },
        (payload) => {
          console.log("Realtime update for trip memberships:", payload);
          onTripsChange();
        }
      )
      .subscribe();
    
    return () => {
      console.log("Cleaning up realtime subscriptions");
      supabase.removeChannel(ownedTripsChannel);
      supabase.removeChannel(joinedTripsChannel);
    };
  }, [user, onTripsChange]);
};
